import { css } from '@emotion/react';

export default $ => css`
  li.dropdown ul {
    display: none;
  }

  .divComponents {
    ul,
    li {
      list-style-type: none;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    li {
      ul:last-child {
        li {
          border-bottom: 0px;
        }
      }
    }

    .shadowBack:hover {
      background-color: #b8b8b84d;
    }

    ul {
      margin: 0;
      padding-inline-start: 10px;

      .dropdown,
      .cssState {
        padding: 3px;
      }
    }

    .pr-10 {
      padding-right: 10px;
    }

    i:not(button) {
      span {
        font-size: 12px;
        font-weight: normal;
        padding: 10px;
        display: none;
      }
    }

    .f-draggable {
      font-weight: bold;
    }

    .droptarget {
      &.up {
        border-top: 2px solid ${$.primaryMain} !important;
      }

      &.down {
        border-bottom: 2px solid ${$.primaryMain} !important;
      }
    }

    .grip-icon {
      display: inline-block;
      width: 1.5em;
      text-align: center;
    }

    .expand-icon {
      margin-right: 2px;
      transition: transform 100ms ease-in-out;

      &:hover {
        transform: scale(1.2);
      }
    }

    .dropZone {
      width: 100% !important;
    }

    .lnkAddOption {
      padding: 7px;
      font-size: 13px;
      font-weight: bold;
      float: right;
      padding-right: 20px;
      cursor: pointer;
    }
  }

  .divComponents {
    background: white;
    padding-bottom: 20px;
  }

  .sidebar-panel:first-of-type > .titleComponents {
    padding: 0.25em;
    border-radius: ${$.borderRadius} ${$.borderRadius} 0 0;
  }

  .titleComponents {
    position: relative;
    background-color: ${$.primaryMain};
    color: white;
    box-sizing: content-box;
    font-size: 1.3rem;

    > .dropdown {
      > .btn.dropdown-toggle {
        text-align: left;
      }
    }

    .buttons {
      position: absolute;
      top: 0;
      right: 12px;

      > .btn {
        background-color: transparent;
        border-width: 0;
        color: #ffffff;
      }
    }
  }

  .titleComponents.form-editor-sidebar-title {
    padding: 0 !important;

    .form-editor-title-text {
      padding: 0.5rem;
    }

    .form-editor-tabs {
      background-color: white;
      font-size: 15px;

      .nav-item {
        flex: 1 0;
        text-align: center;

        > .nav-link {
          border-radius: 0;
          padding: 4px;
        }
      }
    }
  }

  .divComponents.form-editor-sidebar-content {
    display: flex;
    flex-direction: column;

    > .sidebar-panel {
      min-height: 0;
      display: flex;
      flex-direction: column;

      > .collapse {
        min-height: 0;
        overflow: auto;
      }
    }
  }

  ._formEditor {
    gap: 8px;

    .title {
      margin-bottom: 0;
      font-size: 0.9rem;
    }

    .form-check {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }

  .fa.fa-caret-right {
    transition: transform 150ms ease-in-out;

    &.rotate-90-clockwise {
      transform: rotate(90deg);

      &:hover {
        transform: rotate(90deg);
      }
    }
  }

  ._workflowEditor {
    .nav-item {
      flex: 1 0;
      text-align: center;
    }

    .nav-link {
      padding: 4px;
      border-radius: 0px;
      color: black;
    }

    .nav-tabs {
      padding-inline-start: 0;
    }

    .nav.nav-tabs .nav-link.active {
      color: white;
    }

    .nav.nav-tabs .nav-link.active {
      color: white !important;
    }
  }

  .is-sticky {
    position: fixed;
    top: 81px;
    z-index: 999;
    right: 0;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    padding-left: 30px;
    padding-right: 30px;
  }

  .form-component.sidepanel-form {
    > .card {
      border-width: 0;
    }

    &.marginless {
      > .card > .card-body {
        margin: 0;
        padding: 0;
      } 
    }
  }
`;
